import $ from "jquery";
import initializeAutocomplete from "./AutocompleteSearch";
import "jquery-ui";
import "./widgets/get-username";

//Widgets
$('.header').getTopBarInfo();

if ($('#Intra-search-page').length > 0) {
  initializeAutocomplete();
}

$('#vgr-megamenu-search form label')
  .each(function (index, value) {
    $(value).click(function () {
      // På insidans mega meny kan man välja om man ska söka på webb, dokument, person och verksamhet. 
      // Detta sätter formulärets action till det området man har valt att söka inom.
      document.megamenusearch.action = $(value).data('labelaction');
    });
  });

$("#vgr-megamenu-search form").submit(function () {
  var noSubmitElements = ['inputtabwebb', 'inputtabdokument', 'inputtabperson', 'inputtaborganisation'];
  for (var i = 0, j = noSubmitElements.length; i < j; i++) {
    document.getElementById(noSubmitElements[i]).removeAttribute('name');
  }
});

//Office365 waffle
$('#vgr-waffle-button').click(function () {
  var x = document.getElementById("vgrwaffle-nav-navMenuBreak");
  var y = document.getElementsByClassName(".topsite-section");
  if (x.style.display === "none") {
    x.style.display = "block";
  }
  else {
    x.style.display = "none";

  }
});